/**
 * 响应式断点配置
 * 由于 Tailwind v4 中不再使用 tailwind.config.js，
 * 这里的断点需与 `app/styles/theme.css` 中的 `--breakpoint-*` CSS变量保持同步。
 */
export const breakpoints = {
    sm: 767,
    desktop: 1068,
    tablet: 735,
    'm-mobile': 480,
    mobile: 320,
    'w-900': 900,
    'w-960': 960,
} as const;

export type BreakpointName = keyof typeof breakpoints;
